module.exports = __webpack_public_path__ + "static/media/services.50590486.svg";